import Swiper from 'swiper/bundle';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Fancybox } from '@fancyapps/ui';
import Masonry from 'masonry-layout';

gsap.registerPlugin(ScrollTrigger);

function formatDate(dateString) {
  const date = new Date(dateString);

  // console.debug(date.getFullYear());
  // console.debug(date.getMonth());
  // console.debug(date.getDate());

  // 月の名前の配列
  // const months = [
  //   'JAN.',
  //   'FEB.',
  //   'MAR.',
  //   'APR.',
  //   'MAY',
  //   'JUN.',
  //   'JUL.',
  //   'AUG.',
  //   'SEP.',
  //   'OCT.',
  //   'NOV.',
  //   'DEC.',
  // ];
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  // 日付に "st", "nd", "rd", "th" を追加
  // const day = date.getDate();
  // const suffix = (day) => {
  //   if (day > 3 && day < 21) return 'TH';
  //   switch (day % 10) {
  //     case 1:
  //       return 'ST';
  //     case 2:
  //       return 'ND';
  //     case 3:
  //       return 'RD';
  //     default:
  //       return 'TH';
  //   }
  // };

  // 時間をフォーマット
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // フォーマットを構築
  return `${date.getFullYear()}.${
    months[date.getMonth()]
  }.${date.getDate()} | ${hours}:${minutes}`;
}

// 以下の処理はcronで実行
// 0 * * * * /usr/bin/php /apps/get_weather_api.php?opt=run
//
// /apps/reset_json_data.php?opt=destroy でデータを削除
// /apps/reset_json_data.php でデータをリセット

function weather_data_init(pos) {
  //ローカルサーバーのパス /data/weather_base.json と /data/weather_peak.json のデータを取得
  let jsonPath;

  switch (pos) {
    case 'base':
      jsonPath = '/apps/data/weather_base.json';
      break;
    case 'peak':
      jsonPath = '/apps/data/weather_peak.json';
      break;
  }

  // データ取得
  return fetch(jsonPath)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      const currentData = data.data[0];
      return currentData;
    });
}

function replace_top_weather_data() {
  const replaceWeather = document.getElementById('replace-weather');
  if (replaceWeather == null) return;

  const document_lang = document.documentElement.lang;

  let weatherLabel, directionsLabel;
  switch (document_lang) {
    case 'ja':
      weatherLabel = [
        '晴れ',
        '曇り',
        '雨',
        'みぞれ(雨)',
        'みぞれ(雪)',
        '雪',
        '快晴',
        '薄曇り',
        '小雨',
        '小雪',
      ];
      directionsLabel = [
        '静穏',
        'NNE',
        'NE',
        'EN',
        'E',
        'ES',
        'SE',
        'SSE',
        'S',
        'SSW',
        'SW',
        'WS',
        'W',
        'WNW',
        'NW',
        'NNW',
        'N',
      ];
      break;
    case 'en-US':
      weatherLabel = [
        'Clear',
        'Cloudy',
        'Rain',
        'Sleet Rain',
        'Sleet Snow',
        'Snow',
        'Sunny',
        'Partly Cloudy',
        'Light Rain',
        'Light Snow',
      ];
      directionsLabel = [
        'Calm',
        'NNE',
        'NE',
        'EN',
        'E',
        'ES',
        'SE',
        'SSE',
        'S',
        'SSW',
        'SW',
        'WS',
        'W',
        'WNW',
        'NW',
        'NNW',
        'N',
      ];
      break;
  }

  // 天気のリスト
  const weatherList = {
    1: ['clear', weatherLabel[0]],
    2: ['cloudy', weatherLabel[1]],
    3: ['rain', weatherLabel[2]],
    4: ['sleet-rain', weatherLabel[3]],
    5: ['sleet-snow', weatherLabel[4]],
    6: ['snow', weatherLabel[5]],
    11: ['sunny', weatherLabel[6]],
    12: ['partly-cloudy', weatherLabel[7]],
    13: ['light-rain', weatherLabel[8]],
    16: ['light-snow', weatherLabel[9]],
  };

  const windDirectionsList = {
    0: ['calm', directionsLabel[0]],
    1: ['north-northeast', directionsLabel[1]],
    2: ['northeast', directionsLabel[2]],
    3: ['east-northeast', directionsLabel[3]],
    4: ['east', directionsLabel[4]],
    5: ['east-southeast', directionsLabel[5]],
    6: ['southeast', directionsLabel[6]],
    7: ['south-southeast', directionsLabel[7]],
    8: ['south', directionsLabel[8]],
    9: ['south-southwest', directionsLabel[9]],
    10: ['southwest', directionsLabel[10]],
    11: ['west-southwest', directionsLabel[11]],
    12: ['west', directionsLabel[12]],
    13: ['west-northwest', directionsLabel[13]],
    14: ['northwest', directionsLabel[14]],
    15: ['north-northwest', directionsLabel[15]],
    16: ['north', directionsLabel[16]],
  };

  const weatherPos = ['peak', 'base'];
  weatherPos.forEach((pos) => {
    weather_data_init(pos).then((data) => {
      const currentData = data;

      // console.debug(currentData.wind_d);

      const weatherWeather = currentData.wth;
      const weatherTempture = currentData.temp;
      const weatherWindDirections = currentData.wind_d;
      // console.debug(windDirectionsList[weatherWindDirections][0]);

      const weatherWindSpeed = currentData.wind_s;
      const weatherWeatherText = weatherList[weatherWeather];
      const weatherWindDirectionsText =
        windDirectionsList[weatherWindDirections];

      // console.debug(currentData);
      // console.debug('Weather(' + pos + ') updated: ' + currentData.date);

      replaceWeather.querySelector('.js-weather-' + pos + '-label').innerText =
        weatherWeatherText[1];
      replaceWeather.querySelector(
        '.js-weather-' + pos + '-temperature'
      ).innerText = weatherTempture;
      replaceWeather
        .querySelector('.js-weather-' + pos + '-icon')
        .setAttribute('data-weather-type', weatherWeatherText[0]);
      replaceWeather.querySelector(
        '.js-windspeed-' + pos + '-label'
      ).innerText = weatherWindDirectionsText[1];
      replaceWeather.querySelector('.js-windspeed-' + pos + '-data').innerText =
        weatherWindSpeed;
      replaceWeather
        .querySelector('.js-winddirection-' + pos + '-icon')
        .setAttribute('data-wind-direction', weatherWindDirectionsText[0]);

      // 天気APIの更新日時を表示
      document.querySelector('.js-weather-update').innerText = formatDate(
        currentData.date
      );
    });
  });
}

replace_top_weather_data();

// 以下の処理はcronで実行
// 0 * * * * /usr/bin/php /apps/get_yukiyama_api.php?opt=run
//
// /apps/reset_json_data.php?opt=destroy でデータを削除
// /apps/reset_json_data.php でデータをリセット

function yukiyama_data_init(option) {
  // option
  // 1: weather
  // 2: news
  // 3: lift
  // 4: course
  //// 5: park
  //// 6: other

  const document_lang = document.documentElement.lang;
  let jsonData;

  switch (document_lang) {
    case 'ja':
      jsonData = '/apps/data/yukiyama_' + option + '_ja.json';
      break;
    case 'en-US':
      jsonData = '/apps/data/yukiyama_' + option + '_en.json';
      break;
  }

  // データ取得
  return fetch(jsonData)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    });
}

function summer_stat_data_init(option) {
  // option
  // 1: gondola-lift
  // 2: mountain-bike
  // 3: mountain-cart
  // 4: shops
  // 5: restaurants

  const document_lang = document.documentElement.lang;
  let jsonData;

  switch (document_lang) {
    case 'ja':
      jsonData = '/apps/data/summer_stat_' + option + '_ja.json';
      break;
    case 'en-US':
      jsonData = '/apps/data/summer_stat_' + option + '_en.json';
      break;
  }

  // データ取得
  return fetch(jsonData)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    });
}

function replace_top_snow_data() {
  const replaceSnow = document.getElementById('replace-snow');
  if (replaceSnow == null) return;

  yukiyama_data_init('weather').then((data) => {
    const arrayData = data.results;
    arrayData.forEach((result, i) => {
      // console.debug(result.updateDate);

      let pos;
      switch (i) {
        case 0:
          pos = 'peak';
          break;
        case 1:
          pos = 'base';
          break;
      }

      const snowAccumulation =
        result.snow_accumulation != '' ? result.snow_accumulation : '--';
      const snowAccumulationDifference =
        result.snow_accumulation_difference !== ''
          ? result.snow_accumulation_difference
          : '--';
      const snowState = result.snow_state != '' ? result.snow_state : '--';

      // console.debug(result);
      // console.debug('Snow(' + pos + ') updated: ' + result.updateDate);

      replaceSnow.querySelector('.js-snow-' + pos + '-accumulation').innerText =
        snowAccumulation;
      if (pos == 'peak') {
        replaceSnow.querySelector(
          '.js-snow-' + pos + '-accumulation-difference'
        ).innerText = snowAccumulationDifference;
        replaceSnow.querySelector('.js-snow-' + pos + '-state').innerText =
          snowState;
      }
    });
  });
}

replace_top_snow_data();

function replace_top_news_data() {
  const siteSeason = document.body.dataset.season;

  const replaceNews = document.getElementById('replace-news');
  if (replaceNews == null) return;

  const moreLabel = replaceNews.querySelector('.more-report-label');

  const isSmallScreen = window.innerWidth < 760;
  let textSize;

  switch (isSmallScreen) {
    case true:
      textSize = 12;
      break;
    case false:
      textSize = 16;
      break;
  }

  if (siteSeason == 'winter') {
    yukiyama_data_init('news').then((data) => {
      const currentData = data[0];
      const newsMessage = currentData.message;
      // const newsMessage = 'ウィンターシーズンの営業開始は11月30日を予定しております。ウィンターシーズンの営業開始は11月30日を予定しております。';

      // console.debug('News updated: ' + currentData.time);

      replaceNews.querySelector('.js-todays-info p').innerHTML = newsMessage;

      if (moreLabel == null) return;

      const allowTextCount = Math.floor(
        (replaceNews.querySelector('.js-todays-info').offsetWidth / textSize) *
          2
      );
      if (newsMessage.length < allowTextCount) {
        replaceNews.querySelector('.more-report-label').style.display = 'none';
      }
    });
  } else {
    summer_stat_data_init('todays-info').then((data) => {
      const currentData = data[0];
      const newsMessage = currentData.message;
      // const newsMessage = 'ウィンターシーズンの営業開始は11月30日を予定しております。ウィンターシーズンの営業開始は11月30日を予定しております。';

      // console.debug('News updated: ' + currentData.time);

      replaceNews.querySelector('.js-todays-info p').innerHTML = newsMessage;

      if (moreLabel == null) return;

      const allowTextCount = Math.floor(
        (replaceNews.querySelector('.js-todays-info').offsetWidth / textSize) *
          2
      );
      if (newsMessage.length < allowTextCount) {
        replaceNews.querySelector('.more-report-label').style.display = 'none';
      }
    });
  }
}

replace_top_news_data();

function replace_lift_status_data() {
  const replaceLiftStatus = document.getElementById('replace-lift-status');
  if (replaceLiftStatus == null) return;

  const document_lang = document.documentElement.lang;

  let statuslabel, timeBetween;
  switch (document_lang) {
    case 'ja':
      statuslabel = [
        '運行中',
        '減速運転',
        '運行待ち',
        '待機調査中',
        '本日営業終了',
        '運休',
        '営業中',
        '閉鎖中',
      ];
      timeBetween = ' 〜 ';
      break;
    case 'en-US':
      statuslabel = [
        'Operating',
        'Operation slowed',
        'Standby',
        'Operation temporarily suspended',
        'Today Closed',
        'Suspended',
        'Open',
        'Closed',
      ];
      timeBetween = ' - ';
      break;
  }
  const statusList = {
    OPERATING: statuslabel[0],
    OPERATION_SLOWED: statuslabel[1],
    STANDBY: statuslabel[2],
    OPERATION_TEMPORARILY_SUSPENDED: statuslabel[3],
    TODAY_CLOSED: statuslabel[4],
    SUSPENDED: statuslabel[5],
    OPEN: statuslabel[6],
    CLOSED: statuslabel[7],
    COMMING_SOON: 'Comming Soon',
    HOLD: 'Hold',
  };

  const tableBody = replaceLiftStatus.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  yukiyama_data_init('lift').then((data) => {
    const arrayData = data.results;
    arrayData.forEach((result, i) => {
      // 取得データを変数に格納
      const liftName = result.name;
      const liftStatus = statusList[result.status];
      const liftStartTime = result.start_time;
      const liftEndTime = result.end_time;
      const liftComment = result.comment !== '' ? result.comment : '-';
      let liftTime;

      // console.debug(result);
      // console.debug( 'Updated: ' + result.updateDate + ' | ' + liftName);

      if (liftStartTime == '' || liftEndTime == '') {
        liftTime = '-';
      } else {
        liftTime = liftStartTime + timeBetween + liftEndTime;
      }

      // 行とセルを生成
      const row = document.createElement('tr');

      const nameCell = document.createElement('th');
      nameCell.textContent = liftName;

      const statusCell = document.createElement('td');
      statusCell.innerHTML = '<span class="hide">' + liftStatus + '</span > ';
      statusCell.classList.add('stats_' + result.status.toLowerCase());
      statusCell.dataset.liftStatus = liftStatus;

      const hourCell = document.createElement('td');
      hourCell.textContent = liftTime;

      const commentCell = document.createElement('td');
      commentCell.textContent = liftComment;

      // 行にセルを追加
      row.appendChild(nameCell);
      row.appendChild(statusCell);
      row.appendChild(hourCell);
      row.appendChild(commentCell);

      // テーブルに行を追加
      tableBody.appendChild(row);
    });
  });
}

replace_lift_status_data();

function replace_course_info_data() {
  const replaceCourseInfo = document.getElementById('replace-course-info');
  if (replaceCourseInfo == null) return;

  const document_lang = document.documentElement.lang;
  const courseLevelList = {
    904: 'lv1',
    905: 'lv1',
    914: 'lv2',
    912: 'lv1',
    922: 'lv3',
    921: 'lv3',
    913: 'lv1',
    906: 'lv1',
    915: 'lv2',
    907: 'lv1',
    918: 'lv2',
    925: 'lv3',
    908: 'lv1',
    909: 'lv1',
    917: 'lv3',
    916: 'lv2',
    923: 'lv3',
    910: 'lv1',
    924: 'lv3',
    919: 'lv2',
    920: 'lv2',
    926: 'lv3',
  };

  const tableBody = replaceCourseInfo.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  yukiyama_data_init('course').then((data) => {
    const arrayData = data.results;
    arrayData.forEach((result, i) => {
      // console.debug(result);

      // 取得データを変数に格納
      const courseIdNum = result.id;
      const courseName = result.name;
      const courseStatus = result.status;
      const courseGroomed = result.groomed;

      // console.debug( courseLevelList[courseIdNum] );

      if (courseGroomed == 'あり') {
        switch (document_lang) {
          case 'ja':
            courseGroomedLabel = '圧雪';
            break;
          case 'en-US':
            courseGroomedLabel = 'Groomed';
            break;
        }
      }
      const courseComment = result.comment !== '' ? result.comment : '-';
      const courseId = result.object_id;

      if (courseId == '') return;

      // console.debug(courseIdNum);

      // console.debug('Updated: ' + result.updateDate + ' | ' + courseName);

      // 行とセルを生成
      const row = document.createElement('tr');
      row.classList.add('course_' + courseIdNum);

      const nameCell = document.createElement('th');
      nameCell.textContent = courseName;

      const statusCell = document.createElement('td');
      statusCell.innerHTML = '<span class="hide">' + courseStatus + '</span > ';
      statusCell.classList.add('stats_' + courseStatus.toLowerCase());

      const nameDifficulty = document.createElement('td');
      nameDifficulty.innerHTML = '<span class="hide">レベル</span>';
      nameDifficulty.classList.add('stats_' + courseLevelList[courseIdNum]);

      const commentCell = document.createElement('td');
      commentCell.textContent = courseComment;

      // 行にセルを追加
      row.appendChild(nameCell);
      row.appendChild(statusCell);
      row.appendChild(nameDifficulty);
      row.appendChild(commentCell);

      // テーブルに行を追加
      tableBody.appendChild(row);
    });
  });
}

replace_course_info_data();

function replace_summer_lift_status_data() {
  const replaceTarget = document.getElementById('replace-summer-lift-status');
  if (replaceTarget == null) return;

  const documentLang = document.documentElement.lang;

  // let statuslabel, timeBetween;
  // switch (document_lang) {
  //   case 'ja':
  //     statuslabel = ['運行中', '運行待ち', '運休'];
  //     timeBetween = ' 〜 ';
  //     break;
  //   case 'en-US':
  //     statuslabel = ['Operating', 'Standby', 'Closed'];
  //     timeBetween = ' - ';
  //     break;
  // }
  // const statusList = {
  //   open: statuslabel[0],
  //   standby: statuslabel[1],
  //   closed: statuslabel[2],
  // };

  const tableBody = replaceTarget.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  summer_stat_data_init('gondola-lift').then((data) => {
    replace_table_data(data, tableBody, documentLang);
  });
}
replace_summer_lift_status_data();

function replace_mountain_bike_status_data() {
  const replaceTarget = document.getElementById('replace-mountain-bike-status');
  if (replaceTarget == null) return;

  const documentLang = document.documentElement.lang;
  const tableBody = replaceTarget.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  summer_stat_data_init('mountain-bike').then((data) => {
    replace_table_data(data, tableBody, documentLang);
  });
}
replace_mountain_bike_status_data();

function replace_mountain_cart_status_data() {
  const replaceTarget = document.getElementById('replace-mountain-cart-status');
  if (replaceTarget == null) return;

  const documentLang = document.documentElement.lang;
  const tableBody = replaceTarget.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  summer_stat_data_init('mountain-cart').then((data) => {
    replace_table_data(data, tableBody, documentLang);
  });
}
replace_mountain_cart_status_data();

function replace_shops_status_data() {
  const replaceTarget = document.getElementById('replace-shops-status');
  if (replaceTarget == null) return;

  const documentLang = document.documentElement.lang;
  const tableBody = replaceTarget.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  summer_stat_data_init('shops').then((data) => {
    replace_table_data(data, tableBody, documentLang);
  });
}
replace_shops_status_data();

function replace_restaurants_status_data() {
  const replaceTarget = document.getElementById('replace-restaurants-status');
  if (replaceTarget == null) return;

  const documentLang = document.documentElement.lang;
  const tableBody = replaceTarget.querySelector('table tbody');
  while (tableBody.firstChild) {
    tableBody.removeChild(tableBody.firstChild);
  }

  summer_stat_data_init('restaurants').then((data) => {
    replace_table_data(data, tableBody, documentLang);
  });
}
replace_restaurants_status_data();

function replace_table_data(data, table, lang) {
  // console.debug(data);
  // console.debug(table);

  let statuslabel, timeBetween;
  switch (lang) {
    case 'ja':
      statuslabel = ['運行中', '運行待ち', '運休'];
      timeBetween = ' 〜 ';
      break;
    case 'en-US':
      statuslabel = ['Operating', 'Standby', 'Closed'];
      timeBetween = ' - ';
      break;
  }
  const statusList = {
    open: statuslabel[0],
    standby: statuslabel[1],
    closed: statuslabel[2],
  };

  const arrayData = data.results;
  arrayData.forEach((result, i) => {
    // 取得データを変数に格納
    const dataName = result.name;
    const dataStatus = statusList[result.status];
    const dataStartTime = result.start_time;
    const dataEndTime = result.end_time;
    const dataComment = result.comment !== '' ? result.comment : '-';
    let dataTime;

    // console.debug(result);
    // console.debug( 'Updated: ' + result.updateDate + ' | ' + liftName);

    if (dataStartTime == '' || dataEndTime == '') {
      dataTime = '-';
    } else {
      dataTime = dataStartTime + timeBetween + dataEndTime;
    }

    // 行とセルを生成
    const row = document.createElement('tr');
    const nameCell = document.createElement('th');
    nameCell.textContent = dataName;

    const statusCell = document.createElement('td');
    statusCell.innerHTML = '<span class="hide">' + dataStatus + '</span > ';
    statusCell.classList.add('stats_' + result.status + '_sm');
    statusCell.dataset.dataStatus = dataStatus;

    const hourCell = document.createElement('td');
    hourCell.textContent = dataTime;

    const commentCell = document.createElement('td');
    commentCell.textContent = dataComment;

    // 行にセルを追加
    row.appendChild(nameCell);
    row.appendChild(statusCell);
    row.appendChild(hourCell);
    row.appendChild(commentCell);

    // テーブルに行を追加
    table.appendChild(row);
  });
}

// TOPのアクティビティのスライダー処理
function activitiesSwiper() {
  const targetClass = '.js-swiper-activities';
  const slides = document.querySelectorAll(targetClass + ' .swiper-slide');
  let swiperloop = false;

  if (slides.length > 4) {
    swiperloop = true;
  }

  if (document.body.dataset.deviceType === 'desktop') {
    new Swiper(targetClass, {
      speed: 500, // 少しゆっくり(デフォルトは300)
      spaceBetween: 30,
      slidesPerView: 3.3, // スライドの表示枚数
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
  }
}

// 言語切り替えメニューの開閉
function toggleLanguageSwitcher() {
  const bogoSwitch = document.querySelector('.bogo_switch');
  if (bogoSwitch == null) return;

  const bogoLanguageSwitcher = bogoSwitch.querySelector(
    '.bogo-language-switcher'
  );

  bogoSwitch.addEventListener('click', () => {
    bogoLanguageSwitcher.classList.toggle('active');
  });
}

// サブメニューの開閉
function openingSubmenu() {
  const menuItems = document.querySelectorAll('.menu-item-has-children');
  if (menuItems.length === 0) return;

  const navGlobal = document.querySelector('.nav-global');

  // サブメニューのオーバーレイ要素を生成
  const subMenuOverlay = document.createElement('div');
  subMenuOverlay.classList.add('submenu-overlay');
  // subMenuOverlay.style.display = 'none';
  document.body.appendChild(subMenuOverlay);

  let submenuHeights = [];
  menuItems.forEach((menuItem, index) => {
    const submenuHeight = menuItem.children[1].clientHeight;
    // console.debug(menuItem.children[1].clientHeight);
    // console.debug(menuItem.children[1].clientHeight + 38);
    // console.debug('--');
    // console.debug(submenuHeight);

    // 高さを配列に格納
    if (index === 0) {
      submenuHeights.push(submenuHeight + 38);
    } else {
      submenuHeights.push(submenuHeight);
    }
    // 格納後に小要素を非表示にする
    menuItem.children[1].children[0].style.display = 'none';
  });

  // console.debug(submenuHeights);

  menuItems.forEach((menuItem, index) => {
    menuItem.querySelector('a').href = 'javascript:void(0)';

    menuItem.addEventListener('click', (e) => {
      navGlobal.style.setProperty(
        '--submenu-height',
        submenuHeights[index] + 'px'
      );

      // const submenuWrapper = e.target.parentElement.nextElementSibling;
      // console.debug(submenuWrapper);
      // console.debug(submenuWrapper.clientHeight);

      const target = e.target.parentElement.parentElement;

      if (target.classList.contains('active') == false) {
        menuItems.forEach((menuItem) => {
          menuItem.classList.remove('active');
        });

        menuItem.classList.add('active');
        document.body.dataset.submenuStatus = 'open';
      } else {
        target.classList.remove('active');
        document.body.dataset.submenuStatus = 'close';
      }
    });
  });

  closeAnyMenu(menuItems);
}

// ハンバーガーメニューの開閉
function mobileMenu() {
  const navigationMenuToggle = document.getElementById(
    'navigation-menu-toggle'
  );
  // console.debug(navigationMenuToggle);

  if (navigationMenuToggle == null) return;

  const menuItems = document.querySelectorAll('.menu-item-has-children');
  // console.debug(menuItems);

  navigationMenuToggle.addEventListener('click', function (e) {
    // console.debug(e);

    if (document.body.dataset.navigation === 'open') {
      document.body.dataset.navigation = 'close';
      menuItems.forEach((menuItem) => {
        menuItem.classList.remove('active');
      });
    } else {
      document.body.dataset.navigation = 'open';
    }
  });

  closeAnyMenu();
}

// 範囲外のクリックでメニューを閉じる
function closeAnyMenu(menuItems) {
  const subMenuOverlay = document.querySelector('.submenu-overlay');
  if (subMenuOverlay == null) return;

  subMenuOverlay.addEventListener('click', function (event) {
    // console.debug( document.body.dataset.submenuStatus === undefined );
    // console.debug( document.body.dataset.navigation === undefined );

    // return false;
    if (document.body.dataset.submenuStatus !== undefined) {
      if (menuItems != null) {
        menuItems.forEach((menuItem) => {
          menuItem.classList.remove('active');
        });
      }
      document.body.dataset.submenuStatus = 'close';
    }
    if (document.body.dataset.navigation !== undefined) {
      document.body.dataset.navigation = 'close';
    }
  });
}

// 画像の遅延読み込み状況に合わせたステータスの付与
function lazyLoadEvent() {
  const lazyImages = document.querySelectorAll('img.lazy-image');
  if (lazyImages.length === 0) return;

  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const targetElement = img.parentElement.parentElement;

        // 既に読み込み済みの場合
        if (img.complete) {
          targetElement.classList.add('loaded');
        } else {
          // 画像の読み込み完了イベントを設定
          img.addEventListener('load', () => {
            targetElement.classList.add('loaded');
          });

          // 画像の読み込みエラーイベントを設定（必要に応じて）
          img.addEventListener('error', () => {
            // console.error('Image failed to load:', img.src);
          });
        }

        // 監視を停止
        observer.unobserve(img);
      }
    });
  });

  lazyImages.forEach((img) => {
    imageObserver.observe(img);
  });
}

// コンバージョン画面の開閉
function setCvMenu() {
  const btnBuy = document.querySelectorAll('.btn-buy');
  const btnClose = document.querySelector('.close-btn');
  if (btnBuy == null || btnClose == null) return;

  btnBuy.forEach((btn) => {
    btn.addEventListener('click', function (event) {
      if (btn.href.includes('#') === true) {
        event.preventDefault();
        openCvMenu();
      }
    });
  });

  btnClose.addEventListener('click', function (event) {
    event.preventDefault();
    closeCvMenu();
  });
}
function openCvMenu() {
  const menu = document.getElementById('slide-menu');
  menu.style.display = 'block';
  setTimeout(() => {
    menu.style.opacity = '1';
    document.querySelector('.slide-menu-content').classList.add('slide-in');
  }, 10);
}
function closeCvMenu() {
  const menu = document.getElementById('slide-menu');
  menu.style.opacity = '0';
  document.querySelector('.slide-menu-content').classList.remove('slide-in');
  setTimeout(() => {
    menu.style.display = 'none';
  }, 500); // フェードアウトのアニメーション時間と一致させる
}

function slideDelayShow(target) {
  const inner_slides = target.querySelectorAll('.js-slide');
  if (inner_slides.length === 0) return;

  const delay = 0.1;
  let delayTime = 0;
  inner_slides.forEach((inner_slide, i) => {
    inner_slide.style.transitionDelay = `${delayTime}s`;
    inner_slide.style.opacity = 1;
    delayTime += delay;
    // console.debug(inner_slide.style.transitionDelay);
  });
}

// スライドが表示されたときにトリガーとなるclassを付与
function slideInView() {
  const targets = document.querySelectorAll('[watch]');

  if (targets.length === 0) return;

  const observerOptions = {
    root: null, // ビューポートをルートとして使用
    rootMargin: '0px',
    threshold: 0.5, // 10%表示されたときにコールバックを呼び出す
  };

  function handleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        slideDelayShow(entry.target);
        entry.target.classList.add('in-view');
      } else {
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersect, observerOptions);

  targets.forEach((target) => {
    observer.observe(target);
  });
}

// トップのアクティビティが表示されたときにフラグを立てる
// function inviewActivities() {

//   const target = document.getElementById('Activities');
//   if (target == null) return;

//   gsap.to("#Activities",
//     {
//       scrollTrigger: {
//         trigger: "#Activities",
//         start: "top center",
//         toggleActions: "play none none none",
//         onEnter: (e) => {
//           //console.debug(e);
//           document.body.dataset.throughActivities = true;
//         },
//         onLeaveBack: () => {
//           document.body.dataset.throughActivities = false;
//         },
//       },
//   });
// }

function disabledLinks() {
  const disabledLinks = document.querySelectorAll('a.disabled');
  if (disabledLinks.length === 0) return;

  disabledLinks.forEach((disabledLink) => {
    disabledLink.href = 'javascript:void(0)';
    disabledLink.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
}

// Wordpressの多言語URLのルールから漏れるフォームページで言語切り替えのリンクを上書きする処理
// function customLanguageSwitcher() {
//   const hasFormPage = document.querySelector('.form-page-body');
//   if (hasFormPage == null) return;

//   const currentUrl = window.location.href;
//   let otherUrl = '';
//   let jpUrl = '';
//   let enUrl = '';
//   const currentLang = document.documentElement.lang;

//   //現在のURLに /en/ が含まれているかどうかで条件分岐
//   if (currentUrl.includes('/en/')) {
//     //含まれていた場合、/en/ を削除して日本語URLを生成
//     jpUrl = currentUrl.replace('/en/', '/');
//     enUrl = currentUrl;

//   } else {
//     //含まれていなかった場合、/ に /global/ を挿入して英語URLを生成
//     //const enUrl = currentUrl.replace('/', '/global/');
//     jpUrl = currentUrl;
//     enUrl = currentUrl.replace('/global/', '/global/en/');
//   }

//   //現在のURlに　/global/ が含まれていた場合、/global/en/ に置換して英語URLを生成

//   const languageSwitcherAnchor = document.querySelectorAll('.bogo-language-switcher a');
//   languageSwitcherAnchor.forEach((anchor) => {

//     anchor.classList.remove('current');
//     anchor.parentNode.parentNode.classList.remove('current');

//     if (anchor.hreflang === currentLang) {
//       anchor.classList.add('current');
//       anchor.parentNode.parentNode.classList.add('current');
//     }

//     switch (anchor.hreflang) {
//       case 'ja':
//         anchor.href = jpUrl;
//         break;
//       case 'en-US':
//         anchor.href = enUrl;
//         break;
//     }
//   });
// }

// Wordpressの影響が弱いフォームページでリンクを言語別に設定する処理
// function customHomeUrl() {
//   const hasFormPage = document.querySelector('.form-page-body');
//   const currentLang = document.documentElement.lang;

//   if (hasFormPage == null || currentLang == 'ja' ) return;

//   const currentHostname = window.location.hostname;
//   const logoAnchor = document.querySelectorAll('.logo-header a');
//   const menuAnchor = document.querySelectorAll('ul.menu a');
//   const subAnchor = document.querySelectorAll('ul.sub a');
//   const targetAnchor = Array.from(logoAnchor).concat(Array.from(menuAnchor)).concat(Array.from(subAnchor));

//   targetAnchor.forEach((anchor) => {

//     // anchor に currentHostname が含まれている場合
//     if ( anchor.href.includes(currentHostname) ) {
//       console.debug(anchor.href);

//       var newUrl = anchor.href.replace(currentHostname, currentHostname + '/en');
//       anchor.href = newUrl;

//     }

//   });

// }

// 横スクロールギャラリー処理
function scrollInfinity() {
  const scrollInfinities = document.querySelectorAll('.js-scroll-infinity');
  if (scrollInfinities.length === 0) return;

  scrollInfinities.forEach((scrollInfinity) => {
    // ギャラリーの要素が1件しかない場合は処理を中断
    if (scrollInfinity.dataset.galleryCount == 1) return;

    const scrollWrap = scrollInfinity.querySelector('.scroll-infinity__wrap');
    const scrollList = scrollInfinity.querySelector('.scroll-infinity__list');
    const scrollItems = scrollList.querySelectorAll('.scroll-infinity__item');
    const cloneList = scrollList.cloneNode(true);

    cloneList.classList.add('clone');
    scrollWrap.appendChild(cloneList);

    const slideCount = scrollItems.length * 0.7;
    scrollWrap.style = '--slide-count:' + slideCount;

    // setTimeout(() => {
    //   scrollItems.forEach((scrollItem, i) => {
    //     // scrollItem.style = 'opacity: 1; transition-delay:' + i * 0.2 + 's';
    //     scrollItem.style = 'opacity: 1;';
    //   });
    // }, 600);
  });
}

function mapModal() {
  // const fancyboxObjs = document.querySelectorAll("[data-fancybox]");
  // if (fancyboxObjs.length === 0) return;

  Fancybox.bind('[data-fancybox]', {
    // on: {
    //   "Carousel.ready": (fancybox) => {
    //     // console.debug(fancybox.carousel.slides[0].el);
    //     console.debug(fancybox);
    //   }
    // }
    // src: function (e) {
    //   console.debug(e);
    // }
    // Your custom options
  });
}

// function convertDate(dateStr) {

//     // 日付文字列をパースしてDateオブジェクトを作成
//   //const dateStr = "2020-05-13T23:50:45.000000Z";
//   const date = new Date(dateStr);

//   // 月の名前を定義
//   const months = ["JAN.", "FEB.", "MAR.", "APR.", "MAY.", "JUN.", "JUL.", "AUG.", "SEP.", "OCT.", "NOV.", "DEC."];

//   // 年、月、日、時、分を取得
//   const year = date.getUTCFullYear();
//   const month = months[date.getUTCMonth()];
//   const day = date.getUTCDate();
//   const hours = String(date.getUTCHours()).padStart(2, '0');
//   const minutes = String(date.getUTCMinutes()).padStart(2, '0');

//   // 日付のサフィックスを取得する関数
//   function getDaySuffix(day) {
//       if (day > 3 && day < 21) return 'TH';
//       switch (day % 10) {
//           case 1:  return 'ST';
//           case 2:  return 'ND';
//           case 3:  return 'RD';
//           default: return 'TH';
//       }
//   }

//   // 日付のサフィックスを取得
//   const daySuffix = getDaySuffix(day);

//   // フォーマットされた日付文字列を作成
//   const formattedDate = `${year} ${month} ${day}${daySuffix} | ${hours}:${minutes}`;

//   return formattedDate;

// }

function setCookieValue(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function changeSiteLang() {
  // ブラウザの設定言語を取得
  const browserLang = window.navigator.language;
  const siteLang = document.documentElement.lang;
  const path = location.pathname;

  let cookieLang = getCookieValue('lang');
  if (cookieLang === undefined) {
    if (browserLang !== 'ja' && siteLang == 'ja') {
      setCookieValue('lang', 'en-US', 7);
      location.href = '/en' + path;
    }
  }

  setCookieValue('lang', siteLang, 7);
  cookieLang = getCookieValue('lang');
  // console.debug(cookieLang);
}

function masonryInit() {
  const deviceType = document.body.dataset.deviceType;
  const elem = document.querySelector('.masonry-card');
  if (elem == null || deviceType === 'mobile') return;

  const gridChildWidth = elem.firstElementChild.offsetWidth;
  const masonryGrid = new Masonry(elem, {
    // options
    itemSelector: '.card',
    columnWidth: gridChildWidth,
    gutter: 20,
    // percentPosition: true,
    // fitWidth: true,
  });
}

function changeSiteDeviceType() {
  //console.debug(window.innerWidth);

  const windowWidth = window.innerWidth;
  if (windowWidth === undefined) return;

  if (windowWidth < 768) {
    document.body.dataset.deviceType = 'mobile';
  } else if (windowWidth < 1024) {
    document.body.dataset.deviceType = 'tablet';
  } else {
    document.body.dataset.deviceType = 'desktop';
  }
}

function accordionInit(activeIndex = 0) {
  const accordionItems = document.querySelectorAll('.accordion-item');
  if (!accordionItems) return;

  accordionItems.forEach((item, i) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');

    // console.debug(i);
    if (i === activeIndex) {
      item.classList.add('active');
      content.style.height = 'auto';
    }

    header.addEventListener('click', function () {
      const parentElm = this.parentElement;
      const isActive = parentElm.classList.contains('active');

      if (!isActive) {
        parentElm.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
      } else {
        parentElm.classList.remove('active');
        content.style.height = '0';
      }
    });
  });
}

if (typeof activeIndex === 'undefined') {
  let activeIndex = 0; // デフォルト値を設定
}

function checkOs() {
  const ua = navigator.userAgent.toLowerCase();
  //console.debug(ua);

  const htmlElement = document.documentElement;
  const bodyElement = document.body;

  let osClass = '';
  if (ua.indexOf('windows') > -1) {
    osClass = 'windows';
  } else if (ua.indexOf('macintosh') > -1 || ua.indexOf('mac os x') > -1) {
    osClass = 'mac';
  } else if (ua.indexOf('linux') > -1) {
    osClass = 'linux';
  } else if (/android/.test(ua)) {
    osClass = 'android';
  } else if (/iphone|ipad|ipod/.test(ua)) {
    osClass = 'ios';
  } else {
    osClass = 'unknown';
  }

  // 判別結果をbodyのclassに追加
  if (osClass) {
    bodyElement.dataset.deviceOs = osClass;
  }
}

function tabInit() {
  const tabWrappers = document.querySelectorAll('.js-tab-wrapper');

  if (tabWrappers.length === 0) return;

  tabWrappers.forEach((tabWrapper) => {

    const tabButtons = tabWrapper.querySelectorAll('.tab-menu li');
    const tabContents = tabWrapper.querySelectorAll('.tab-content');

    tabButtons.forEach((tabButton, index) => {

      if( index === 0 ){
        tabContents[index].classList.add('active');
        tabContents[index].style.display = 'block';
      }

      tabButton.addEventListener('click', function () {
        // すべてのタブを非アクティブにする
        tabButtons.forEach((btn) => {
          btn.classList.remove('active');
        });

        // クリックされたタブをアクティブにする
        this.classList.add('active');

        // 対応するコンテンツを表示
        const contentId = this.dataset.tab;


        tabContents.forEach((content) => {
          if (content.id === contentId) {
            content.style.display = 'block';
          } else {
            content.style.display = 'none';
          }
        });
      });
    });

  });

}

function fixedTableInit() {
  // .site-header の高さを格納
  const siteHeaderHeight = document.querySelector('.site-header')?.offsetHeight - 1 || 0;

  //
  const tables = document.querySelectorAll('.fixed-table');
  if (tables.length === 0) return;
  tables.forEach((table) => {
    const tableHeader = table.querySelector('thead');
    tableHeader.style.setProperty('--header-height', siteHeaderHeight + 'px');

    // tableHeader 内の tr 要素の数を取得
    const headerRows = tableHeader.querySelectorAll('tr');
    table.classList.add('header-rows-' + headerRows.length);
    // console.debug(table);
    // console.debug(headerRows.length);

  });

  // console.debug(siteHeaderHeight);

}

function init() {
  fixedTableInit();
  tabInit();
  checkOs();
  changeSiteDeviceType();

  if (document.body.dataset.deviceType === 'desktop') {
    const swiperRecommendations = new Swiper('.js-swiper-recommendations', {
      slidesPerView: 1.05, // スライド数
      spaceBetween: '15', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          slidesPerView: 2.32, // スライド数
          spaceBetween: 15,
        },
      },
    });

    const swiperNews = new Swiper('.js-swiper-news', {
      slidesPerView: 1.2, // スライド数
      spaceBetween: '15', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 30,
          slidesPerView: 3.3, // スライド数
        },
      },
    });

    const swiperEvents = new Swiper('.js-swiper-events', {
      slidesPerView: 1.2, // スライド数
      spaceBetween: '15', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 30,
          slidesPerView: 3.3, // スライド数
        },
      },
    });

    const swiperArticle = new Swiper('.js-swiper-article', {
      slidesPerView: 1.2, // スライド数
      spaceBetween: '10', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      loop: true,
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          centeredSlides: true, // 1枚目のスライドを中央にする
          slidesPerView: 'auto',
          spaceBetween: 15,
        },
      },
    });

    const swiperFooterBanner = new Swiper('.js-swiper-footer-banners2', {
      spaceBetween: 15,
      slidesPerView: 2,
      centeredSlides: true, // 1枚目のスライドを中央にする
      loop: true,
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          slidesPerView: 'auto',
          spaceBetween: 15,
        },
      },
    });

    const swiperActivitiesSingle = new Swiper('.js-swiper-activities-single', {
      slidesPerView: 1.2, // スライド数
      spaceBetween: '15', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 30,
          slidesPerView: 3, // スライド数
        },
      },
    });
  }

  // スマートフォンの画面の際のみSwiperを初期化
  if (document.body.dataset.deviceType === 'mobile') {
    const swiperArticleFooter = new Swiper('.js-swiper-article-footer', {
      slidesPerView: 1.2, // スライド数
      spaceBetween: '15', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 30,
          slidesPerView: 'auto',
        },
      },
    });

    const swiperRentalMerit = new Swiper('.js-swiper-rental-merit', {
      slidesPerView: 1.3, // スライド数
      spaceBetween: '15', // スライド間の余白
      grabCursor: true, // カーソルを置いたときに指のカーソルを表示
      // pagination: {
      //   el: ".swiper-pagination",
      //   type: "progressbar",
      // },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 30,
          slidesPerView: 'auto',
        },
      },
    });
  }

  // json_sync_test();
  // weather_data_init();

  changeSiteLang();
  mapModal();

  scrollInfinity();
  activitiesSwiper();

  toggleLanguageSwitcher();
  openingSubmenu();
  mobileMenu();
  setCvMenu();
  lazyLoadEvent();

  slideInView();
  // inviewActivities();
  disabledLinks();

  masonryInit();

  let activeIndex = 0;
  if (document.body.classList.contains('page-tickets') === true) {
    const nowDate = new Date();
    // console.debug(nowDate);

    // const formatter = new Intl.DateTimeFormat('ja-JP', { timeZone: 'Asia/Tokyo' });
    // const options = { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' };

    // const dateJst = formatter.format(nowDate);
    // console.debug(dateJst);

    const date1 = new Date('2024/12/14'); // 1つ目の基準日
    const date2 = new Date('2025/03/24'); // 2つ目の基準日

    if (nowDate >= date1 && nowDate < date2) {
      activeIndex = 1;
    } else if (nowDate >= date2) {
      activeIndex = 2;
    } else {
      activeIndex = 0;
    }
  }

  // console.debug(activeIndex);
  accordionInit(activeIndex);
}
document.addEventListener('DOMContentLoaded', init);

(function () {
  let initialWidth = window.innerWidth;
  let resizeTimeout;

  function handleResize() {
    if (document.body.dataset.deviceType === 'mobile') return;

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth !== initialWidth) {
        location.reload();
      }
    }, 1000);
  }

  window.addEventListener('resize', handleResize);
})();
